var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ModalPrompt"},[_c('h1',[_vm._v("Invite a new user to "+_vm._s(_vm.org.name))])]),_vm._v(" "),_c('div',{staticClass:"ModalBody"},[_c('SimpleForm',{attrs:{"onSubmit":_vm.onSubmit,"fields":[
                    {
                        label : 'First name',
                        name : 'first_name',
                        autofocus : true,
                        required : true,
                    },
                    {
                        label : 'Last name',
                        name : 'last_name',
                        required : true,
                    },
                    {
                        label : 'Email address',
                        name : 'email',
                        type : 'email',
                        required : true,
                    },
                    {
                        name : 'org_id',
                        type : 'hidden',
                    } ],"model":{ org_id : _vm.org.id }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }